import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { notify } from '../../AtomStore/store';
import { Link } from 'react-router-dom';

const FootprintNotification = () => {
  const [notification, setNotification] = useAtom(notify);
  useEffect(() => {
    if (notification && notification.subtitle) {
      const timer = setTimeout(() => {
        setNotification();
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, [notification, setNotification]);

  const removeHtmlTags = message => {
    if (typeof message === 'string') {
      const regex = /(<([^>]+)>)/gi;
      return message.replace(regex, '');
    }
    return message;
  };

  if (notification?.title && typeof notification?.subtitle === 'string') {
    const { subtitle = "test subtitle notification", title= 'Test notification' } = notification;
    return (
      <Link
        to={`/notification`}
        onClick={() => {
          // window.location = '/notification';
          setNotification({ title: '', subtitle: '' });
        }}
        className='fixed inset-0 flex items-center justify-center z-50'
      >
        <div
          className='max-w-80 w-80 rounded'
        >
          {/* <Card className="border-0 shadow h-100 rounded">
            <CardHeader
              className="border-0 bg-teal rounded-t text-white"
              style={{ fontFamily: 'Baloo'}}
            >
              {title && title !== '' ? title : 'Footprints Childcare'}
            </CardHeader>
            <CardBody className="p-3">
              <Row>
                <CardImg
                  style={{ width: 100, height: 100 }}
                  width={100}
                  height={100}
                  src={require('../../assets/splash-nico-hi.png')}
                  alt="Card image cap"
                />
                <CardTitle
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: 280,
                    fontSize: '13px',
                    justifyContent: 'center',
                    height: 50,
                  }}
                  className="my-auto pr-3"
                >
                  {subtitle && subtitle !== ''
                    ? subtitle
                    : 'Footprints Childcare'}
                </CardTitle>
              </Row>
            </CardBody>
          </Card> */}
          <div className='flex flex-col w-100 bg-white text-gray-dark'>
            <div className='bg-header text-lg font-medium text-white py-2 px-4 rounded-t font-robo'>
              {title && title !== '' ? title : 'Footprints Childcare'}
            </div>
            <div className='rounded-b py-2 px-4 flex gap-4 items-center justify-start bg-annual bg-opacity-10'>
              <div className='relative'>
                <img className='h-20 w-20 z-10' src={require('../../assets/splash-nico-hi.png')} alt='footprints logo' />
                {/* <div className='animate-pulse bg-header h-10 w-10 rounded-full absolute top-0 z-0'></div> */}
              </div>
              <div className='break-all text-sm flex-wrap max-w-40'>
              {subtitle && subtitle !== ''
                    ? subtitle
                    : 'Footprints Childcare'}
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
  return <div />;
};

export default FootprintNotification;
